import { useState, useEffect, type Dispatch, type SetStateAction } from 'react';

// used for getting / storing workspace id in local storage
export const useLocalStorage = <T>(storageKey: string, fallbackState: T): [T, Dispatch<SetStateAction<T>>] => {
  const [value, setValue] = useState<T>(JSON.parse(localStorage.getItem(storageKey) as string) ?? fallbackState);

  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(value));
  }, [value, storageKey]);

  return [value, setValue];
};
